import React from 'react';
import { SimChartAssignment } from 'models/ui';
import { ELSButton } from 'components/common/els';
import MarAdministerItem from './MarAdministerItem';
import { MarAdministerFormField } from './MarAdministerSidebar';
import MarAdministerTextbox from './MarAdministerTextbox';

interface MarAdministerStep1Props {
  patientIDField: MarAdministerFormField;
  formField: MarAdministerFormField[];
  fullAssignment: SimChartAssignment;
  onChange: Function;
  onBlur: Function;
  onCheckboxHandler: Function;
  onSkipBarcode: Function;
  onSkipBarcodeAll: Function;
  checkDisabledButton: Function;
  setPatientIDField: Function;
  handleContinue: Function;
  messageBarcode: Function;
  validatePatientID: Function;
}

const MarAdministerStep1 = ({
  patientIDField,
  formField,
  fullAssignment,
  onChange,
  onBlur,
  onCheckboxHandler,
  onSkipBarcode,
  onSkipBarcodeAll,
  checkDisabledButton,
  setPatientIDField,
  handleContinue,
  messageBarcode,
  validatePatientID
}: MarAdministerStep1Props) => {
  return (
    <>
      <div className="mar-administer-sidebar__patient-info">{messageBarcode()}</div>
      <div className="mar-administer-sidebar__actions">
        {fullAssignment?.barcodeEnabled && (
          <>
            <MarAdministerTextbox
              formFieldItem={patientIDField}
              onChange={(e) => setPatientIDField({ ...patientIDField, value: e.target.value })}
              onBlur={(e) => setPatientIDField({ ...patientIDField, value: e.target.value, error: validatePatientID(e.target.value), isTouched: true })}
              isDisabled={patientIDField?.skipBarCode}
              showCheckmark
            />
            <ELSButton type="debuttonize" text={patientIDField?.skipBarCode ? 'Include Barcode' : 'Skip Barcode'} className="skip-btn" onClick={onSkipBarcodeAll} />
          </>
        )}
      </div>
      <div className="mar-administer-sidebar__list">
        {formField?.map((record) => (
          <MarAdministerItem
            formFieldItem={record}
            key={`${record.id}-${record.dosageTimeTable}-${record.dosageTimeSeparate} `}
            onChange={(e) => onChange(e, record)}
            onBlur={(e) => onBlur(e, record)}
            checkboxHandler={(e) => onCheckboxHandler(e, record)}
            isSingle={formField.length === 1}
            onSkipBarcode={onSkipBarcode}
          />
        ))}
      </div>
      <ELSButton className="action-btn" iconSize="1x" iconName="chevron-right" iconPosition="right" text="Continue" onClick={handleContinue} isDisabled={checkDisabledButton()} />
    </>
  );
};

export default MarAdministerStep1;
